import React from 'react';
import { cn } from '@/utils/cn';

export function ProjectPersonnelKpiRow({ kpis }: { kpis: any[] }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {kpis.map((kpi, idx) => (
        <div key={idx} className="bg-white p-3 space-y-2 rounded-md border border-slate-100 flex flex-col group hover:border-slate-200 transition-all">
          <div className="flex items-center gap-2">
            <div className={cn("p-2 rounded-md flex items-center justify-center shrink-0", kpi.bg, kpi.color)}>
             <i className={cn(kpi.icon, "text-lg")} />
          </div>
          <div className="min-w-0 flex-1">
             <h4 className="sm:text-sm text-xs font-normal text-slate-500 truncate">{kpi.label}</h4>
             <div className="flex items-baseline gap-1.5 flex-wrap">
                <span className="text-xl font-normal text-slate-900 leading-none">{kpi.value}</span>
                <span className="sm:text-sm text-xs font-normal text-slate-500">{kpi.unit}</span>
                {kpi.percent && (
                  <span className={cn(
                    "sm:text-sm text-xs font-normal ml-auto",
                    kpi.label.includes('Chi phí') ? 'text-emerald-500' : 'text-slate-400'
                  )}>
                    {kpi.percent}% {kpi.subtitle && idx !== 5 ? '' : ''}
                  </span>
                )}
             </div>
          </div>
          </div>
          {kpi.subtitle && (
            <div className="pt-2 border-t border-slate-50">
               <p className="sm:text-sm text-xs font-normal text-slate-500">{kpi.subtitle}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
